var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative overflow-hidden",class:_vm.roundedClass},[_c('div',{staticClass:"bg-gray-200 absolute inset-x-0 h-full",class:[_vm.barHeight, _vm.roundedClass]}),_c('div',{staticClass:"transition-all duration-500 relative w-full",class:[_vm.barHeight, _vm.roundedClass],style:([
      {
        'background-color': _vm.color,
        transform: _vm.getPercentage()
      }
    ])})])}
var staticRenderFns = []

export { render, staticRenderFns }